module.exports = __webpack_public_path__ + "img/tip4.db025183.png";